import { makeStyles, withStyles } from '@material-ui/core/styles';
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from 'react-router-dom';
import { getConsultingId, getUrlLogo } from '../../utils/utils';

//Text field 
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import MyDatePicker from '../../utils/MyDatePicker';
import MySelect from '../../utils/MySelect';
import MySwitch from '../../utils/MySwitch';
import MyTextField from '../../utils/MyTextField';
import { isValidCnpj, justNumbers } from '../../utils/utils';


//UnoButton

//getSuitabilityOptions
import { getSuitabilityIndex, getSuitabilityOptions } from '../../utils/suitability';

//Grid
import { Grid, Tooltip, Typography } from "@material-ui/core";

//API
import { CepAPI } from '../../../API/cep';
import { CityAPI } from '../../../API/city';
import { ClientAPI } from '../../../API/client';
import { ClientContractValuesAPI } from '../../../API/client_contract_values';
//Utils
import { applyMaskAmount, isValidCep } from '../../utils/utils';
import { getContractValueAt } from '../../utils/contractValues';
import UnoButton from '../../utils/UnoButton';

//Modals
import ConfirmActionModal from '../../modals/ConfirmActionModal';
import SelectAndCropImageModal from '../../modals/SelectAndCropImageModal';
import UpdateAssetsInitsModal from '../../modals/UpdateAssetsInitsModal';

//Controllers
import { saveLogResetPortfolio } from '../../../controllers/LogActionController';

//Redux
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";



import moment from 'moment';
import { headerSearch, unoTheme } from "../../../assets/styles/unoTheme";

// Utils
import _, { isEmpty } from 'lodash';
import { checkUserIsRole, roles } from '../../utils/user.js';
import { useMemo } from 'react';
import DefaultScrollWithHeaderContent from '../../utils/DefaultScrollWithHeaderContent.js';

const LightTooltip = withStyles((theme) => ({
    arrow: {
        "&:before": {
            border: "1px solid #000000"
        },
        color: theme.palette.common.white
    },
    tooltip: {
        fontSize: '15px',
        backgroundColor: theme.palette.common.white,
        border: "1px solid #000000",
        color: "#000000"
    }
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
    },

    main: {
        padding: theme.spacing(2),
        overflowY: 'scroll',
    },

    headerSearch: headerSearch,
    switchs: {

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',

        '& .MuiTypography-root': {
            marginTop: '-2px',
        }

    },
    progressInput: {
        width: '20px !important',
        height: '20px !important',
    },

    promanagementValidity: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: "16px",
    },

    buttonsHeader: {
        display: 'flex',
        alignItems: 'center',
    },

    maginRight2: {
        marginRight: theme.spacing(2),
    },
    input: {
        display: 'none',
    },

    imageSelected: {
        width: '100px',
        borderRadius: '10px',
        float: 'left',
        cursor: 'pointer',
        //border: 'solid 1px ' + unoTheme.mainColor
    },

    //MyTextField só renderiza helperText quando validator é verdadeiro, então o contador de
    //caracteres vive num Typography irmão do campo
    observationCounter: {
        fontSize: '12px',
        textAlign: 'right',
        color: unoTheme.secondaryColor,
    }

}));

//Espelha o VARCHAR(1000) de client_observations.observation. Vai no campo como `inputProps`
//(minúsculo): MyTextField sobrescreve o `InputProps` que recebe, mas o minúsculo passa direto para
//o <input>, e é o maxLength nativo que trava a digitação no limite.
export const CLIENT_OBSERVATION_MAX_LENGTH = 1000;

export const classificationsMap = {
    AA: {
        label: 'Alta prioridade e alta complexidade',
        color: '#e67c73'
    },
    AB: {
        label: 'Alta prioridade e média complexidade',
        color: '#ee9a6f'
    },
    BA: {
        label: 'Média prioridade e alta complexidade',
        color: '#f6b86b'
    },
    BB: {
        label: 'Média prioridade e média complexidade',
        color: '#ffd666'
    },
    BC: {
        label: 'Média prioridade e baixa complexidade',
        color: '#c8ce71'
    },
    CB: {
        label: 'Baixa prioridade e média complexidade',
        color: '#90c57d'
    },
    CC: {
        label: 'Baixa prioridade e baixa complexidade',
        color: '#57bb8a'
    },
    null: {
        label: 'Não classificado',
        color: '#bababa'
    }
};

export default function NewClientScreen({
    clientOnScreen,
    flagSaveClient,
    flagUpdateClient }) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const clientOn = useSelector(state => state.clientOn)
    const currentUser = useSelector(state => state.currentUser)
    const rightContent = useSelector(state => state.rightContent)

    const location = useLocation();
    const history = useHistory();

    const [listPromanagements,] = useState([
        'Não',
        'PG I',
        'PG II',
        'PG III',
        'PG IV',
    ])

    const [listSuitabilityOptions,] = useState(getSuitabilityOptions())

    //form new client
    const [submitted, setSubmitted] = useState(false);

    const [client, setClient] = useState(undefined)
    const [initClient, setInitClient] = useState(undefined);
    //CLIENT
    const [inputClientNameRpps, setInputClientNameRpps] = useState("");
    function changeClientNameRpps(value) {
        setInputClientNameRpps(value)
    }

    const [inputClientInitialRpps, setInputClientInitialRpps] = useState("");
    const [openClientInitialValidatedTooltip, setOpenClientInitialValidatedTooltip] = useState(false);

    function containsSpecialChars(str) {
        const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        return specialChars.test(str);
    }

    function changeClientInitialRpps(value) {
        let newValue = value;
        if (containsSpecialChars(newValue)) {
            newValue = newValue.replace(/[^a-zA-Z0-9 ]/g, '');;
            //newValue = newValue.replace('/', '');
            setOpenClientInitialValidatedTooltip(true);
        }
        setInputClientInitialRpps(newValue)
    }

    const [inputClientCep, setInputClientCep] = useState("");
    const [infosCep, setInfosCep] = useState("");

    async function changeClientCep(value) {

        if (value.length <= 9) {

            setInputClientCep(value)
            if (value.length == 9) {

                setInfosCep("searching");

                let responseCep = await CepAPI.getInfosByCep(value);

                if (responseCep.body.erro) {
                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        type: 'warning',
                        message: "CEP não encontrado"
                    }));

                    setInfosCep("");
                    setInputClientStreet("");
                    setInputClientNeighborhood("");
                    setInputClientCity("");
                    setInputClientUF("");
                } else {
                    setInfosCep(responseCep.body);
                    setInputClientStreet(responseCep.body.logradouro);
                    setInputClientNeighborhood(responseCep.body.bairro);
                    setInputClientCity(responseCep.body.localidade);
                    setInputClientUF(responseCep.body.uf);
                }
            }

        }
    }

    const [inputClientStreet, setInputClientStreet] = useState("");
    function changeClientStreet(value) {
        setInputClientStreet(value)
    }

    const [inputClientNeighborhood, setInputClientNeighborhood] = useState("");
    function changeClientNeighborhood(value) {
        setInputClientNeighborhood(value)
    }

    const [inputClientNumberAddress, setInputClientNumberAddress] = useState("");
    function changeClientNumberAddress(value) {
        setInputClientNumberAddress(value)
    }

    const [inputClientComplementAddress, setInputClientComplementAddress] = useState("");
    function changeClientComplementAddress(value) {
        setInputClientComplementAddress(value)
    }

    const [inputClientCity, setInputClientCity] = useState("");
    function changeClientCity(value) {
        setInputClientCity(value)
    }

    const [inputClientUF, setInputClientUF] = useState("");
    function changeClientUF(value) {
        setInputClientUF(value)
    }

    const [inputClientInstituitionalEmail, setInputClientInstituitionalEmail] = useState("");
    function changeClientInstituitionalEmail(value) {
        setInputClientInstituitionalEmail(value)
    }

    const [inputClientCnpj, setInputClientCnpj] = useState("");
    function changeClientCnpj(value) {
        setInputClientCnpj(value)
    }

    const [inputClientCnpjCityHall, setInputClientCnpjCityHall] = useState("");
    function changeClientCnpjCityHall(value) {
        setInputClientCnpjCityHall(value)
    }

    // The first commit of Material-UI
    //const [selectedDate, setSelectedDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0));
    const [selectedDate, setSelectedDate] = useState(new Date(2020, 12, 0));
    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const [inputClientPortfolioSegregated, setInputClientPortfolioSegregated] = useState(false);
    const changePortfolioSegregated = (event) => {
        setInputClientPortfolioSegregated(event.target.checked);
    };

    //Militar
    const [inputClientMilitary, setInputClientMilitary] = useState(false);
    const changeClientMilitary = (event) => {
        setInputClientMilitary(event.target.checked);
    };

    //Aporte e Fundo de Oscilação de Risco (uma flag para os dois regimes)
    const [inputClientAporteFor, setInputClientAporteFor] = useState(false);
    const changeClientAporteFor = (event) => {
        setInputClientAporteFor(event.target.checked);
    };

    const [inputClientUfRpps, setInputClientUfRpps] = useState(false);
    const changeClientUfRpps = (event) => {
        setInputClientAssistRpps(false);
        if (event.target.checked) {
            setInputClientCnpjCityHall("");
        }
        setInputClientUfRpps(event.target.checked);
    };

    const [inputClientAssistRpps, setInputClientAssistRpps] = useState(false);
    const changeClientAssistRpps = (event) => {
        //setInputClientUfRpps(false)
        setInputClientAssistRpps(event.target.checked);
    };

    const [inputIsAbleCurrentMonth, setInputIsAbleCurrentMonth] = useState(false);
    const changeInputIsAbleCurrentMonth = (event) => {
        setInputIsAbleCurrentMonth(event.target.checked);
    };

    //Cotização segregada
    const [inputCotizationSegregation, setInputCotizationSegregation] = useState(false);
    const [openCotizationSegregationModal, setOpenCotizationSegregationModal] = useState(false);

    const changeInputCotizationSegregation = (event) => {
        setInputCotizationSegregation(event.target.checked);
    };

    //UNO v2
    const [inputUnoV2, setInputUnoV2] = useState(false);
    const changeInputUnoV2 = (event) => {
        setInputUnoV2(event.target.checked);
    };

    async function handleCotizationSegregationModalAction(confirmed) {
        setOpenCotizationSegregationModal(false);
        if (!confirmed) return;

        dispatch(allActions.fullLoadActions.setFullLoad({
            show: true,
            message: "Resetando carteira..."
        }));

        const savedPortfolioClosed = currentPortfolioClosed;
        const response = await ClientAPI.resetPortfolio(client.id, null, null, true);

        dispatch(allActions.fullLoadActions.setFullLoad({ show: false }));

        if (response.success) {
            if (clientOn?.client?.id === client.id) {
                const updatedClient = { ...clientOn.client, portfolio_closed: null, updateInfosClient: true };
                dispatch(allActions.clientActions.setClient(updatedClient));
            }

            setCurrentPortfolioClosed(null);

            await saveLogResetPortfolio(currentUser.user.id, client.id, null, savedPortfolioClosed);

            await doUpdateClient({ preventDefault: () => { } }, pendingUpdateAssetsValidatedRef.current, true);
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: "Falha ao resetar a carteira!"
            }));
        }
    }

    //Valor mensal do contrato (Lema/Consultoria): histórico em client_contract_values, mantido pelo
    //painel "Histórico". O campo só exibe o valor vigente hoje.
    const [contractValues, setContractValues] = useState([]);
    const currentContractValue = getContractValueAt(contractValues, moment.utc());

    async function loadContractValues(clientId) {
        const response = await ClientContractValuesAPI.listByClient(clientId);
        return response.success && response.body ? response.body.rows : [];
    }

    function openContractValuesHistory(event) {
        //O UnoButton repassa type='primary' ao <button>; tipo inválido vira submit e, dentro do
        //<form> da tela, o clique recarregaria a página em vez de abrir o painel
        event.preventDefault();
        dispatch(allActions.rightContentActions.setRightContent({
            path: 'clientContractValuesHistory',
            clientOnScreen: client,
        }));
    }

    const [inputClientPromanagement, setInputClientPromanagement] = useState(0);

    //Vigência do nível de Pró-Gestão
    const [inputPromanagementInit, setInputPromanagementInit] = useState(null);
    const [inputPromanagementEnd, setInputPromanagementEnd] = useState(null);

    //MySelect é um NativeSelect: e.target.value chega como string ("2"), enquanto o valor vindo do
    //banco é number. Number() cobre os dois casos.
    const hasPromanagement = Number(inputClientPromanagement) > 0;

    function changePromanagementCode(event) {
        const value = event.target.value;
        setInputClientPromanagement(value);
        //Sem Pró-Gestão não existe vigência: limpa para gravar null
        if (!(Number(value) > 0)) {
            setInputPromanagementInit(null);
            setInputPromanagementEnd(null);
        }
    }

    //Mesmo formato do portfolio_init no payload; o servidor normaliza para instante UTC
    function formatPromanagementDate(date) {
        return date && moment.utc(date).isValid() ? moment.utc(date).format('DD/MM/YYYY') : null;
    }

    //Fim precisa ser posterior ao início; compara os moments do estado, não as strings do payload
    const isPromanagementValidityInverted = hasPromanagement
        && inputPromanagementInit && moment.utc(inputPromanagementInit).isValid()
        && inputPromanagementEnd && moment.utc(inputPromanagementEnd).isValid()
        && moment.utc(inputPromanagementEnd).isSameOrBefore(moment.utc(inputPromanagementInit), 'day');

    const [inputClientSuitability, setInputClientSuitability] = useState(null);

    const [inputClientClassification, setInputClientClassification] = useState("null");

    //Observações: anotação interna da LEMA, guardada em client_observations (uma linha por edição)
    const [inputClientObservation, setInputClientObservation] = useState("");
    //Snapshot do que veio do banco: só grava - e só cria versão nova de histórico - se mudou
    const [initClientObservation, setInitClientObservation] = useState("");

    function changeClientObservation(value) {
        //O maxLength do input já trava a digitação; o corte aqui cobre colagem de texto maior
        setInputClientObservation(value.slice(0, CLIENT_OBSERVATION_MAX_LENGTH));
    }

    async function updateActiveClients() {

        const response = await ClientAPI.listAllActiveClients(getConsultingId(currentUser));

        if (response.success) {
            dispatch(allActions.clientActions.setActiveClients(response.body.rows));
        }

    }


    //Para validar atualização de início de carteira
    const [currentPortfolioClosed, setCurrentPortfolioClosed] = useState(null);

    //Upload LOGO
    const inputImageFile = useRef(null);
    const [showSelectAndCropImage, setShowSelectAndCropImage] = useState(false)
    const [imgSrc, setImgSrc] = useState('');
    const [cropSelected, setCropSelected] = useState('');

    function doClickInputImageFile() {
        inputImageFile.current.click()
    }

    function handleActionSelectedAndCropImageModal(action) {
        if (action) {
            console.log('action: ', action);
            const dataUrlBase64 = action.toDataURL()
            console.log('BASE 64: ', dataUrlBase64);
            setCropSelected(dataUrlBase64);
        }
        setShowSelectAndCropImage(false)
    }

    function onSelectFile(e) {
        if (e.target.files && e.target.files.length > 0) {

            setShowSelectAndCropImage(true);
            const reader = new FileReader()
            reader.addEventListener('load', () =>
                setImgSrc(reader.result.toString() || ''),
            )
            reader.readAsDataURL(e.target.files[0])
        }
    }

    async function doUpdateLogoClient(clientId, logo) {
        const reponseUpdateLogo = await ClientAPI.updateLogoClient(clientId, logo);
        return reponseUpdateLogo;
    }

    async function doSaveClient(event) {

        event.preventDefault();

        setSubmitted(true);

        let client = {
            rpps_name: inputClientNameRpps,
            rpps_name_initial: inputClientInitialRpps,
            cpf_cnpj: inputClientCnpj,
            cnpj_city_hall: inputClientCnpjCityHall,
            street_address: inputClientStreet,
            number_address: inputClientNumberAddress,
            neighborhood: inputClientNeighborhood,
            complement: inputClientComplementAddress,
            cep: inputClientCep,
            city_id: "",
            institutional_email: inputClientInstituitionalEmail,
            portfolio_segregated: inputClientPortfolioSegregated,
            portfolio_init: moment.utc(selectedDate).format("DD/MM/YYYY"),
            promanagement_code: inputClientPromanagement,
            promanagement_code_init: hasPromanagement ? formatPromanagementDate(inputPromanagementInit) : null,
            promanagement_code_end: hasPromanagement ? formatPromanagementDate(inputPromanagementEnd) : null,
            suitability: inputClientSuitability != null ? listSuitabilityOptions[inputClientSuitability] : null,
            is_uf_rpps: inputClientUfRpps,
            is_assist_rpps: inputClientAssistRpps,
            is_able_transactions_current_month: inputIsAbleCurrentMonth,
            is_cotization_segregation: inputCotizationSegregation,
            is_military_segregation: inputClientMilitary,
            is_aporte_for_segregation: inputClientAporteFor,
            uno_v2: inputUnoV2,
            classification: inputClientClassification === "null" ? null : inputClientClassification,
            consulting_id: getConsultingId(currentUser)
        }

        //validação prévia
        if (isValidCnpj(justNumbers(client.cpf_cnpj))
            && isValidCep(justNumbers(client.cep))
            && client.rpps_name != ""
            && client.street_address != ""
            && client.neighborhood != ""
            && client.suitability !== null
            && (!hasPromanagement || (client.promanagement_code_init && client.promanagement_code_end))
            && client.consulting_id) {

            if (isPromanagementValidityInverted) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'warning',
                    message: "O fim da vigência do Pró-Gestão deve ser posterior ao início"

                }));
                return;
            }

            if (client.cnpj_city_hall != "" && !isValidCnpj(client.cnpj_city_hall)) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'warning',
                    message: "CNPJ de Prefeitura inválido"

                }));
                return;
            }

            setSubmitted(false);

            // dispatch(allActions.fullLoadActions.setFullLoad({
            //     show: true,
            //     message: "Cadastrando cliente..."
            // }))

            const responseCity = await CityAPI.getCitByCityNameAndUf(inputClientCity, inputClientUF)


            if (responseCity.success && responseCity.body) {

                const { id: cityId, state_id } = responseCity.body;

                client.city_id = cityId;

                //checando se já existe cliente cadastrado para esse municipio
                const responseCheck = await ClientAPI.getClientsByCityId(client.city_id);
                console.log('responseCheck: ', responseCheck);
                if (responseCheck.success) {

                    let normalRppsAble = true;
                    let ufRppsAble = true;
                    let assistRppsAble = true;
                    let ufAssistRppsAble = true;

                    if (responseCheck.body
                        && responseCheck.body.rows
                        && responseCheck.body.rows.length > 0) {

                        responseCheck.body.rows.forEach(element => {

                            console.log('element.is_uf_rpps: ', element.is_uf_rpps);
                            console.log('element.is_assist_rpps: ', element.is_assist_rpps);

                            if (element.is_uf_rpps && !element.is_assist_rpps) {
                                ufRppsAble = false;
                            }
                            if (element.is_assist_rpps && !element.is_uf_rpps) {
                                assistRppsAble = false;
                            }
                            if (!element.is_uf_rpps && !element.is_assist_rpps) {
                                normalRppsAble = false;
                            }
                            if (element.is_uf_rpps && element.is_assist_rpps) {
                                ufAssistRppsAble = false;
                            }

                        });

                    }

                    // console.log('normalRppsAble: ', normalRppsAble);
                    // console.log('ufRppsAble: ', ufRppsAble);
                    // console.log('assistRppsAble: ', assistRppsAble);
                    // console.log('ufAssistRppsAble: ', ufAssistRppsAble);

                    if (client.is_uf_rpps && !ufRppsAble) {

                        dispatch(allActions.mainAlertActions.setMainAlert({
                            show: true,
                            type: 'error',
                            message: "Já existe cadastro de RPPS para esse ESTADO"

                        }));

                        return;

                    }

                    if (client.is_assist_rpps && !assistRppsAble) {

                        dispatch(allActions.mainAlertActions.setMainAlert({
                            show: true,
                            type: 'error',
                            message: "Já existe cadastro de RPPS ASSISTÊNCIA para esse MUNICÍPIO"

                        }));

                        return;

                    }

                    if (!client.is_assist_rpps && !client.is_uf_rpps && !normalRppsAble) {

                        dispatch(allActions.mainAlertActions.setMainAlert({
                            show: true,
                            type: 'error',
                            message: "Já existe cadastro de RPPS para esse MUNICÍPIO. Considere marcar uma das opções UF RPPS ou ASSIST RPPS"

                        }));

                        return;

                    }

                    if (client.is_assist_rpps && client.is_uf_rpps && !ufAssistRppsAble) {

                        dispatch(allActions.mainAlertActions.setMainAlert({
                            show: true,
                            type: 'error',
                            message: "Já existe cadastro de RPPS ASSIST para esse ESTADO"

                        }));

                        return;

                    }

                    const response = await ClientAPI.createClient({
                        ...client,
                        uf_rpps_id: client.is_uf_rpps ? state_id : null,
                    });

                    if (response.success) {

                        console.log("RESPONSE CLIENTE CREATE: ", response);
                        console.log("cropSelected: ", cropSelected);

                        if (cropSelected) {
                            const responseUpdateImage = await doUpdateLogoClient(response.body.client_id, cropSelected);
                        }

                        //A observação vive em tabela própria, então só pode ser gravada depois que
                        //o cliente existe. Uma falha aqui não invalida o cadastro já criado.
                        if (isInternUser && inputClientObservation.trim()) {
                            const responseObservation = await ClientAPI.saveClientObservation(response.body.client_id, inputClientObservation);
                            if (!responseObservation.success) {
                                console.log("ERRO AO SALVAR OBSERVAÇÕES: ", responseObservation);
                            }
                        }

                        dispatch(allActions.mainAlertActions.setMainAlert({
                            show: true,
                            type: 'success',
                            message: "Cliente cadastrado com sucesso"

                        }));

                        clearForm();

                        updateActiveClients();

                        dispatch(allActions.fullLoadActions.setFullLoad({
                            show: false,
                        }))

                        history.push('/administration/clients');

                    } else {

                        dispatch(allActions.fullLoadActions.setFullLoad({
                            show: false,
                        }))

                        dispatch(allActions.mainAlertActions.setMainAlert({
                            show: true,
                            type: 'error',
                            message: "Erro ao cadastrar o cliente: " + response.body.message

                        }));
                    }



                } else {

                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        type: 'error',
                        message: "Erro ao verificar possíveis cadastros pelo ID do municipio"

                    }));
                }


            } else {

                dispatch(allActions.fullLoadActions.setFullLoad({
                    show: false,
                }))
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'error',
                    message: "Erro ao obter código de cidade"

                }));
            }


        } else {



            console.log("Não passou pre validação")
            console.log("moment.isDate(selectedDate): ", moment.isDate(selectedDate))
            console.log("suitability ", inputClientSuitability)
            console.log("selectedDate: ", selectedDate)

        }


    }

    async function doUpdateClient(event, updateAssetsInitValidated, cotizationSegregationConfirmed) {

        event.preventDefault();

        setSubmitted(true);

        let newClient = {
            rpps_name: inputClientNameRpps,
            rpps_name_initial: inputClientInitialRpps,
            cpf_cnpj: inputClientCnpj,
            cnpj_city_hall: inputClientCnpjCityHall,
            street_address: inputClientStreet,
            number_address: inputClientNumberAddress,
            neighborhood: inputClientNeighborhood,
            complement: inputClientComplementAddress,
            cep: inputClientCep,
            city_id: "",
            institutional_email: inputClientInstituitionalEmail,
            portfolio_segregated: inputClientPortfolioSegregated,
            portfolio_init: moment.utc(selectedDate).format("DD/MM/YYYY"),
            //portfolio_init: selectedDate,
            promanagement_code: inputClientPromanagement,
            promanagement_code_init: hasPromanagement ? formatPromanagementDate(inputPromanagementInit) : null,
            promanagement_code_end: hasPromanagement ? formatPromanagementDate(inputPromanagementEnd) : null,
            is_military_segregation: inputClientMilitary,
            is_aporte_for_segregation: inputClientAporteFor,
            is_able_transactions_current_month: inputIsAbleCurrentMonth,
            is_cotization_segregation: inputCotizationSegregation,
            uno_v2: inputUnoV2,
            suitability: inputClientSuitability != null ? listSuitabilityOptions[inputClientSuitability] : null,
            classification: inputClientClassification === "null" ? null : inputClientClassification,
            consulting_id: getConsultingId(currentUser)
        }

        //validação prévia
        if (isValidCnpj(newClient.cpf_cnpj)
            && isValidCep(newClient.cep)
            && newClient.rpps_name != ""
            && newClient.street_address != ""
            && newClient.neighborhood != ""
            && newClient.suitability != null
            && (!hasPromanagement || (newClient.promanagement_code_init && newClient.promanagement_code_end))
            && newClient.consulting_id) {

            //Antes de qualquer modal para que uma vigência inválida não dispare os fluxos de carteira
            if (isPromanagementValidityInverted) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'warning',
                    message: "O fim da vigência do Pró-Gestão deve ser posterior ao início"

                }));
                return;
            }

            if (inputClientObservation.trim().length > CLIENT_OBSERVATION_MAX_LENGTH) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'warning',
                    message: "As observações excederam o limite de " + CLIENT_OBSERVATION_MAX_LENGTH + " caracteres"

                }));
                return;
            }

            setSubmitted(false);

            //Verificando se houve alteração de inicio de carteira
            //só deve ser permitido o início caso a carteira esteja aberta
            if (!selectedDate.isSame(oldInitPortfolio) && currentPortfolioClosed) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'warning',
                    message: "Não é permitido alterar data de inicio de carteira sem resetar o fechamento do cliente"

                }));
                return;
            }

            if (!selectedDate.isSame(oldInitPortfolio) && updateAssetsInitValidated === null) {
                setOpenUpdateAssetsModal(true);
                return;
            }

            const cotizationChangingToTrue = inputCotizationSegregation &&
                client && !client.is_cotization_segregation &&
                currentPortfolioClosed !== null;

            if (cotizationChangingToTrue && !cotizationSegregationConfirmed) {
                pendingUpdateAssetsValidatedRef.current = updateAssetsInitValidated;
                setOpenCotizationSegregationModal(true);
                return;
            }

            if (newClient.cnpj_city_hall && newClient.cnpj_city_hall.trim() != "" && !isValidCnpj(newClient.cnpj_city_hall)) {
                console.log("CNPJ de Prefeitura inválido:", newClient.cnpj_city_hall);
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'warning',
                    message: "CNPJ de Prefeitura inválido"

                }));
                return;
            }

            dispatch(allActions.fullLoadActions.setFullLoad({
                show: true,
                message: "Atualizando cliente..."
            }))

            //Observações moram em client_observations, não em clients: são gravadas aqui, fora do
            //UPDATE. Guardamos se houve alteração porque o _.isEqual(initClient, newClient) abaixo
            //não conhece o campo, e mexer só na observação cairia no "nenhuma alteração detectada".
            let observationSaved = false;
            if (isInternUser && inputClientObservation.trim() !== initClientObservation.trim()) {

                const responseObservation = await ClientAPI.saveClientObservation(client.id, inputClientObservation);

                if (!responseObservation.success) {
                    dispatch(allActions.fullLoadActions.setFullLoad({
                        show: false,
                    }))
                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        type: 'error',
                        message: "Falha ao salvar as observações do cliente"

                    }));
                    return;
                }

                setInitClientObservation(inputClientObservation.trim());
                observationSaved = true;
            }

            const responseCity = await CityAPI.getCitByCityNameAndUf(inputClientCity, inputClientUF)

            if (responseCity.success && responseCity.body) {

                const { id: cityId, state_id } = responseCity.body;

                newClient.city_id = cityId;

                if (!_.isEqual(initClient, newClient)) {

                    let response = await ClientAPI.updateClient(client.id, newClient);

                    if (response.success) {


                        let newLogoPath = null;
                        if (cropSelected) {

                            const responseUpdateImage = await doUpdateLogoClient(client.id, cropSelected);
                            if (responseUpdateImage.success) {
                                //console.log("NEW LOGO PATH: ", responseUpdateImage.body.path);
                                newLogoPath = responseUpdateImage.body.path;
                            }

                        }

                        //updateActiveClients();

                        dispatch(allActions.mainAlertActions.setMainAlert({
                            show: true,
                            type: 'success',
                            message: "Cliente atualizado com sucesso"

                        }));

                        console.log("RESPONSE UPATE OK: ", response)

                        if (clientOn
                            && clientOn.client
                            && clientOn.client.id == response.body.id) {

                            clientOn.client.updateInfosClient = true;
                            if (newLogoPath) {
                                response.body.logo_path = newLogoPath;
                            }
                            let updatedClient = {
                                ...clientOn.client,
                                ...response.body
                            }

                            console.log("Atualizando cliente: ", updatedClient);
                            dispatch(allActions.clientActions.setClient(updatedClient))
                        }

                        dispatch(allActions.fullLoadActions.setFullLoad({
                            show: false,
                        }))

                        history.push('/administration/clients');

                    } else {

                        console.log("RESPONSE ERROR: ", response)

                        dispatch(allActions.fullLoadActions.setFullLoad({
                            show: false,
                        }))

                        dispatch(allActions.mainAlertActions.setMainAlert({
                            show: true,
                            type: 'error',
                            message: "Erro ao cadastrar o cliente: " + response.body.message

                        }));
                    }

                } else {

                    if (cropSelected) {

                        const responseUpdateImage = await doUpdateLogoClient(client.id, cropSelected);

                        dispatch(allActions.fullLoadActions.setFullLoad({
                            show: false,
                        }))
                        if (responseUpdateImage.success) {

                            dispatch(allActions.mainAlertActions.setMainAlert({
                                show: true,
                                type: 'success',
                                message: "Cliente atualizado com sucesso"

                            }));
                        } else {
                            dispatch(allActions.mainAlertActions.setMainAlert({
                                show: true,
                                type: 'error',
                                message: "Falha ao atualizar a logo"

                            }));
                        }


                    } else {

                        dispatch(allActions.fullLoadActions.setFullLoad({
                            show: false,
                        }))

                        dispatch(allActions.mainAlertActions.setMainAlert({
                            show: true,
                            type: observationSaved ? 'success' : 'warning',
                            message: observationSaved ? "Cliente atualizado com sucesso" : "Nenhuma alteração foi detectada"

                        }));
                    }


                }





            } else {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'error',
                    message: "Erro ao obter código de cidade"

                }));
            }


        } else {
            console.log("Não passou pre validação")
            console.log("suitability ", inputClientSuitability)
        }


    }

    function clearForm() {

        setInputClientNameRpps("");
        setInputClientInitialRpps("");
        setInputClientCep("");
        setInfosCep("");
        setInputClientStreet("")
        setInputClientNumberAddress("");
        setInputClientNeighborhood("");
        setInputClientComplementAddress("");
        setInputClientCity("");
        setInputClientUF("");
        setInputClientCnpj("");
        setInputClientCnpjCityHall("");
        setInputClientInstituitionalEmail("");
        setSelectedDate(new Date())
        setInputClientPortfolioSegregated(false);
        setInputClientMilitary(false);
        setInputClientAporteFor(false);
        setInputUnoV2(false);
        setInputClientPromanagement(0);
        setInputPromanagementInit(null);
        setInputPromanagementEnd(null);
        setInputClientSuitability(null);
        setInputClientClassification("null");
        setInputClientUfRpps(false);
        setInputClientAssistRpps(false);
        setInputClientObservation("");
        setInitClientObservation("");
    }

    const [clientInited, setClientInited] = useState(false);
    function initForm(client) {

        console.log("CLIENT TO UPDATE: ", client);
        console.log("CLIENT TO UPDATE: ", moment.utc(client.portfolio_init).format("DD/MM/YYYY"));


        setInputClientNameRpps(client.rpps_name);
        setInputClientInitialRpps(client.rpps_name_initial);
        setInputClientCep(client.cep);
        setInfosCep("");
        setInputClientStreet(client.street_address)
        setInputClientNumberAddress(client.number_address);
        setInputClientNeighborhood(client.neighborhood);
        setInputClientComplementAddress(client.complement);
        setInputClientCity(client.city_name);
        setInputClientUF(client.uf);
        setInputClientCnpj(client.cpf_cnpj);
        setInputClientCnpjCityHall(client.cnpj_city_hall);
        setInputClientInstituitionalEmail(client.institutional_email);
        const initPortfolio = moment.utc(client.portfolio_init);
        setSelectedDate(initPortfolio);
        setOldInitPortfolio(initPortfolio);
        setInputClientPortfolioSegregated(client.portfolio_segregated);
        setInputClientMilitary(client.is_military_segregation);
        setInputClientAporteFor(client.is_aporte_for_segregation);
        setInputClientPromanagement(client.promanagement_code);
        setInputPromanagementInit(client.promanagement_code_init ? moment.utc(client.promanagement_code_init) : null);
        setInputPromanagementEnd(client.promanagement_code_end ? moment.utc(client.promanagement_code_end) : null);
        setInputClientSuitability(getSuitabilityIndex(client.suitability));
        setInputClientClassification(client.classification || "null");
        setInputClientUfRpps(client.is_uf_rpps);
        setInputClientAssistRpps(client.is_assist_rpps);
        setInputIsAbleCurrentMonth(client.is_able_transactions_current_month);
        setInputCotizationSegregation(client.is_cotization_segregation);
        setInputUnoV2(!!client.uno_v2);

        setCurrentPortfolioClosed(client.portfolio_closed)

        setInitClient({
            rpps_name: client.rpps_name,
            rpps_name_initial: client.rpps_name_initial,
            cpf_cnpj: client.cpf_cnpj,
            street_address: client.street_address,
            number_address: client.number_address,
            neighborhood: client.neighborhood,
            complement: client.complement,
            cep: client.cep,
            city_id: client.city_id,
            institutional_email: client.institutional_email,
            portfolio_segregated: client.portfolio_segregated,
            portfolio_init: moment.utc(client.portfolio_init).format("MM/YYYY"),
            promanagement_code: client.promanagement_code,
            promanagement_code_init: client.promanagement_code_init ? moment.utc(client.promanagement_code_init).format('DD/MM/YYYY') : null,
            promanagement_code_end: client.promanagement_code_end ? moment.utc(client.promanagement_code_end).format('DD/MM/YYYY') : null,
            suitability: client.suitability,
            is_military_segregation: client.is_military_segregation,
            is_aporte_for_segregation: client.is_aporte_for_segregation,
        })

        setClientInited(true);
    };

    const isSearchingByCEP = infosCep === "searching";

    const isCurrentUserRoleManager = currentUser.user && currentUser.user.role === roles.manager.title;

    //Reset de ativos e contas a aprtir de um novo inicio de carteira
    const [openUpdateAssetsModal, setOpenUpdateAssetsModal] = useState(false);
    const [oldInitPortfolio, setOldInitPortfolio] = useState();
    const pendingUpdateAssetsValidatedRef = useRef(null);

    const isInternUser = useMemo(() => {
        if (!currentUser?.user) return;
        return checkUserIsRole(currentUser, [roles.superadmin, roles.admin, roles.advisor])

    }, [currentUser])

    //Effect próprio: o useEffect grande roda a cada submit (flagSaveClient/flagUpdateClient nas
    //deps) e recarregar a observação ali sobrescreveria o que o usuário acabou de digitar.
    //A rota é restrita por role no servidor, então nem chamamos para sessões do RPPS.
    useEffect(() => {

        if (!client || !client.id || !isInternUser) return;

        let ignore = false;

        (async () => {
            const response = await ClientAPI.getClientObservation(client.id);
            if (ignore) return;

            const observation = response.success && response.body ? response.body.observation : "";
            setInputClientObservation(observation);
            setInitClientObservation(observation);
        })();

        return () => { ignore = true; };

    }, [client, isInternUser])

    //Mesmo motivo da observação para não ficar no useEffect dos flags
    useEffect(() => {

        if (!client || !client.id) return;

        let ignore = false;

        (async () => {
            const rows = await loadContractValues(client.id);
            if (!ignore) setContractValues(rows);
        })();

        return () => { ignore = true; };

    }, [client])

    //Recarrega o valor vigente sempre que o painel de histórico fecha. Não dá para depender só do
    //update() que o painel dispara no X: clicar no backdrop (UnoDashboard) e o Esc (RightContent)
    //fecham com setRightContent(null) direto, sem passar pelo painel.
    const contractHistoryOpenRef = useRef(false);
    useEffect(() => {

        const isOpen = !!rightContent && rightContent.path === 'clientContractValuesHistory';
        const historyClosed = contractHistoryOpenRef.current && !isOpen;
        contractHistoryOpenRef.current = isOpen;

        //Depois do update() o rightContent fica aberto sem conteúdo e precisa ser fechado aqui
        const isUpdate = !!rightContent && rightContent.action === 'update';

        if (!historyClosed && !isUpdate) return;

        (async () => {
            if (historyClosed && client && client.id) {
                setContractValues(await loadContractValues(client.id));
            }
            if (isUpdate) {
                dispatch(allActions.rightContentActions.setRightContent(null));
            }
        })();

    }, [rightContent])

    useEffect(() => {

        if (!client) {

            if (clientOnScreen) {

                setClient(clientOnScreen)

            }
            // if (location && location.state) {

            //     setClient(location.state.client)

            // }

        } else {
            console.log("Passou aqui");
            //console.log("submitted: ", submitted);
            if (!clientInited) {
                initForm(client);
            }
        }

        if (flagSaveClient) {

            doSaveClient(flagSaveClient);

        }

        if (flagUpdateClient) {

            doUpdateClient(flagUpdateClient, null);

        }


    }, [client,
        clientOnScreen,
        flagSaveClient,
        flagUpdateClient]);

    return (
        <div className={classes.root}>

            <DefaultScrollWithHeaderContent>
                <div className={classes.main}>
                    <form className={classes.rootForm} noValidate autoComplete="off">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={isInternUser ? 6 : 8} md={isInternUser ? 6 : 8}>
                                <MyTextField required
                                    id="client_name_rpps"
                                    outerlabel="Nome do RPPS"
                                    size={'small'}
                                    variant="outlined"
                                    value={inputClientNameRpps}
                                    validator={inputClientNameRpps == "" && submitted ? true : undefined}
                                    helperText={"Insira o nome do RPPS"}
                                    onChange={changeClientNameRpps} />
                            </Grid>
                            <Grid item xs={12} sm={isInternUser ? 3 : 4} md={isInternUser ? 3 : 4}>
                                <LightTooltip open={openClientInitialValidatedTooltip}
                                    arrow
                                    interactive={true}
                                    title='Caracteres especiais como ( \ / : * ? " < > | ) não são permitidos'
                                    placement="top">
                                    <MyTextField
                                        id="client_initial_rpps"
                                        outerlabel="Sigla"
                                        size={'small'}
                                        variant="outlined"
                                        onBlur={() => setOpenClientInitialValidatedTooltip(false)}
                                        value={inputClientInitialRpps}
                                        helperText={"Insira a sigla"}
                                        onChange={changeClientInitialRpps} />
                                </LightTooltip>

                            </Grid>
                            {
                                isInternUser ?
                                    <Grid item xs={12} sm={3} md={3}>
                                        <MySelect
                                            outerlabel={'Classificação'}
                                            value={inputClientClassification}
                                            onChange={(e) => setInputClientClassification(e.target.value)}
                                            options={Object.entries(classificationsMap).map(([key, item]) => (
                                                <option key={'client-classification-' + key} value={key}>
                                                    {(key != "null" ? (key + " - ") : "") + item.label}
                                                </option>
                                            ))}
                                        />

                                    </Grid> : null
                            }
                            <Grid item xs={12} sm={3} md={3}>
                                <MyTextField
                                    id="client_cep"
                                    disabled={isSearchingByCEP || isCurrentUserRoleManager}
                                    value={inputClientCep}
                                    onChange={changeClientCep}
                                    size={'small'}
                                    variant="outlined"
                                    validator={!isValidCep(inputClientCep) && submitted ? true : undefined}
                                    helperText={"Insira o CEP"}
                                    mask={['cep']}
                                    outerlabel="CEP"
                                    endadornment={
                                        <>
                                            {
                                                infosCep == "searching" ?
                                                    <InputAdornment position="end">
                                                        <CircularProgress className={classes.progressInput} />
                                                    </InputAdornment> : null

                                            }
                                        </>

                                    }
                                />


                            </Grid>
                            <Grid item xs={12} sm={7} md={7}>
                                <MyTextField required
                                    id="client_street"
                                    outerlabel="Rua"
                                    // disabled={infosCep == ""
                                    //     || infosCep == "searching"
                                    //     || (infosCep.logradouro && infosCep.logradouro != "")}
                                    size={'small'}
                                    variant="outlined"
                                    value={inputClientStreet}
                                    validator={infosCep != "" && infosCep != 'searching' ? inputClientStreet == "" && submitted : null}
                                    helperText={"Insira a rua"}
                                    onChange={(value) => changeClientStreet(value)} />
                            </Grid>
                            <Grid item xs={12} sm={2} md={2}>
                                <MyTextField
                                    id="client_number_address"
                                    disabled={isEmpty(infosCep) || isSearchingByCEP || isCurrentUserRoleManager}
                                    value={inputClientNumberAddress}
                                    onChange={(value) => changeClientNumberAddress(value)}
                                    size={'small'}
                                    variant="outlined"
                                    mask={['onlyNumbers']}
                                    outerlabel="N°" />
                            </Grid>

                            <Grid item xs={12} sm={3} md={3} lg={3}>
                                <MyTextField
                                    id="client_complement_address"
                                    disabled={isEmpty(infosCep) || isSearchingByCEP || isCurrentUserRoleManager}
                                    value={inputClientComplementAddress}
                                    size={'small'}
                                    onChange={(value) => changeClientComplementAddress(value)}
                                    variant="outlined"
                                    outerlabel="Complemento" />
                            </Grid>

                            <Grid item xs={12} sm={3} md={3}>
                                <MyTextField
                                    id="client_neighborhood"
                                    // disabled={infosCep == ""
                                    //     || infosCep == "searching"
                                    //     || (infosCep.bairro && infosCep.bairro != "")}
                                    value={inputClientNeighborhood}
                                    variant="outlined"
                                    size={'small'}
                                    onChange={(value) => changeClientNeighborhood(value)}
                                    validator={infosCep != "" && infosCep != 'searching' ? inputClientNeighborhood == "" && submitted : null}
                                    helperText={"Insira o bairro"}
                                    outerlabel="Bairro" />
                            </Grid>

                            <Grid item xs={12} sm={3} md={3}>
                                <MyTextField
                                    id="client_city"
                                    disabled={true}
                                    value={inputClientCity}
                                    variant="outlined"
                                    size={'small'}
                                    onChange={(value) => changeClientCity(value)}
                                    helperText={"Insira a cidade"}
                                    outerlabel="Cidade" />
                            </Grid>

                            <Grid item xs={12} sm={4} md={3} lg={3} className={classes.switchs}>

                                <div style={{ width: '80px' }}>
                                    <MyTextField
                                        id="client_uf"
                                        disabled={true}
                                        value={inputClientUF}
                                        variant="outlined"
                                        size={'small'}
                                        onChange={(value) => changeClientUF(value)}
                                        helperText={"Insira a UF"}
                                        outerlabel="UF" />
                                </div>

                                <MySwitch
                                    disabled={isCurrentUserRoleManager || clientOnScreen}
                                    outerlabel={'UF RPPS?'}
                                    checked={inputClientUfRpps}
                                    onChange={changeClientUfRpps}
                                    color="primary" />

                                <MySwitch
                                    disabled={isCurrentUserRoleManager || clientOnScreen}
                                    outerlabel={'ASSIST RPPS?'}
                                    checked={inputClientAssistRpps}
                                    onChange={changeClientAssistRpps}
                                    color="primary" />





                            </Grid>

                            <Grid item xs={12} sm={3} md={3}>
                                <MyTextField
                                    id="client_cnpj"
                                    value={inputClientCnpj}
                                    variant="outlined"
                                    size={'small'}
                                    onChange={changeClientCnpj}
                                    validator={!isValidCnpj(inputClientCnpj) && submitted ? true : undefined}
                                    helperText={"Insira um CNPJ válido"}
                                    mask={["cnpj"]}
                                    outerlabel="CNPJ" />
                            </Grid>

                            <Grid item xs={12} sm={3} md={3}>
                                <MyTextField
                                    id="client_institutional_email"
                                    value={inputClientInstituitionalEmail}
                                    variant="outlined"
                                    size={'small'}
                                    onChange={changeClientInstituitionalEmail}
                                    outerlabel="Email institucional" />
                            </Grid>
                            <Grid item xs={12} sm={2} md={2} lg={2}>

                                <MyDatePicker
                                    disabled={isCurrentUserRoleManager}
                                    className={classes.myDatePicker}
                                    views={["month", "year"]}
                                    margin="dense"
                                    id="date-picker-dialog"
                                    outerlabel="Início carteira"
                                    format="MM/yyyy"
                                    value={selectedDate}
                                    onChange={handleDateChange}
                                // validator={!moment.isDate(selectedDate) && submitted ? true : undefined}
                                // helperText={"Data inválida"}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={4} lg={4} className={classes.switchs}>

                                <MySwitch
                                    disabled={isCurrentUserRoleManager}
                                    outerlabel={'Segregado?'}
                                    checked={inputClientPortfolioSegregated}
                                    onChange={changePortfolioSegregated}
                                    name="portfolioSegregated"
                                    color="primary" />
                                <MySwitch
                                    disabled={!inputClientUfRpps}
                                    outerlabel={'Militar?'}
                                    checked={inputClientMilitary}
                                    onChange={changeClientMilitary}
                                    name="isClientMilitary"
                                    color="primary" />
                                <MySwitch
                                    outerlabel={'Aporte/FOR?'}
                                    checked={inputClientAporteFor}
                                    onChange={changeClientAporteFor}
                                    name="isClientAporteFor"
                                    color="primary" />
                                {/* <MySwitch
                                    outerlabel={'Pró-Gestão?'}
                                    checked={inputClientPromanagement}
                                    onChange={changePromanagement}
                                    name="promanagemente"
                                    color="primary" /> */}

                            </Grid>



                            <Grid item xs={12} sm={3} md={3} lg={3}>
                                <MySelect
                                    initblank
                                    outerlabel={'SUITABILITY'}
                                    value={inputClientSuitability}
                                    onChange={(e) => setInputClientSuitability(e.target.value)}
                                    options={listSuitabilityOptions.map((row, index) => (
                                        <option key={'client-suitability-' + index} value={index}>{row}</option>
                                    ))}
                                    helperText={"Insira o perfil suitability"}
                                    validator={inputClientSuitability == null && submitted ? true : undefined}
                                />

                            </Grid>

                            <Grid item xs={12} sm={3} md={3} lg={3}>
                                <MyTextField
                                    id="client_cnpj_city_hall"
                                    value={inputClientCnpjCityHall}
                                    variant="outlined"
                                    size={'small'}
                                    disabled={inputClientUfRpps}
                                    onChange={changeClientCnpjCityHall}
                                    mask={["cnpj"]}
                                    outerlabel="CNPJ Prefeitura" />

                            </Grid>

                            <Grid item xs={12} sm={2} md={2} lg={2}>
                                <MyTextField
                                    id="client_valor_contrato"
                                    value={currentContractValue !== null ? applyMaskAmount(currentContractValue, true) : ''}
                                    variant="outlined"
                                    size={'small'}
                                    disabled={true}
                                    outerlabel="Valor Mensal Contrato"
                                    endadornment={
                                        //O disabled do campo não chega ao botão: o histórico abre mesmo com o valor travado
                                        <InputAdornment position="end">
                                            <UnoButton
                                                size='verySmall'
                                                type='primary'
                                                variant="contained"
                                                disabled={!client || !client.id}
                                                onClick={openContractValuesHistory}>
                                                Histórico
                                            </UnoButton>
                                        </InputAdornment>
                                    } />

                            </Grid>

                            {
                                checkUserIsRole(currentUser, [roles.superadmin, roles.admin, roles.advisor]) ?
                                    <Grid item xs={12} sm={4} md={4} lg={4} className={classes.switchs}>



                                        <MySwitch
                                            outerlabel={'MÊS VIG.?'}
                                            checked={inputIsAbleCurrentMonth}
                                            onChange={changeInputIsAbleCurrentMonth}
                                            color="primary" />


                                        <MySwitch
                                            outerlabel={'COT. SEG?'}
                                            checked={inputCotizationSegregation}
                                            onChange={changeInputCotizationSegregation}
                                            color="primary" />

                                        <MySwitch
                                            outerlabel={'UNO v2?'}
                                            checked={inputUnoV2}
                                            onChange={changeInputUnoV2}
                                            disabled={!checkUserIsRole(currentUser, [roles.superadmin])}
                                            color="primary" />



                                    </Grid>
                                    : null
                            }

                            <Grid item xs={12} sm={6} md={6} lg={6} className={classes.promanagementValidity}>
                                <MySelect
                                    disabled={isCurrentUserRoleManager}
                                    outerlabel={'PRÓ-GESTÃO'}
                                    value={inputClientPromanagement}
                                    onChange={changePromanagementCode}
                                    options={listPromanagements.map((row, index) => (
                                        <option key={'client-promanagement-' + index} value={index}>{row}</option>
                                    ))}
                                />
                                <MyDatePicker
                                    style={{ width: "100%" }}
                                    disabled={isCurrentUserRoleManager || !hasPromanagement}
                                    margin="dense"
                                    outerlabel="Início Pró-Gestão"
                                    format="DD/MM/YYYY"
                                    value={inputPromanagementInit}
                                    onChange={(value) => setInputPromanagementInit(value)}
                                    validator={hasPromanagement && submitted && !inputPromanagementInit ? true : undefined}
                                    helperText={"Insira uma data válida"} />

                                <MyDatePicker
                                    style={{ width: "100%" }}
                                    disabled={isCurrentUserRoleManager || !hasPromanagement}
                                    margin="dense"
                                    outerlabel="Fim Pró-Gestão"
                                    format="DD/MM/YYYY"
                                    value={inputPromanagementEnd}
                                    onChange={(value) => setInputPromanagementEnd(value)}
                                    validator={hasPromanagement && submitted && !inputPromanagementEnd ? true : undefined}
                                    helperText={"Insira uma data válida"} />
                            </Grid>



                            <Grid item xs={12} sm={3} md={3} lg={3}>
                                <MyTextField
                                    size={'small'}
                                    outerlabel="Logo"
                                    inputImageComponent={
                                        <>
                                            <input ref={inputImageFile} style={{ marginTop: '12px', display: cropSelected || getUrlLogo(clientOnScreen) ? 'none' : 'block' }} type="file" accept="image/*" onChange={onSelectFile} />
                                            <img style={{ marginTop: '5px' }} className={classes.imageSelected} src={cropSelected ? cropSelected : getUrlLogo(clientOnScreen)} onClick={() => doClickInputImageFile()} />
                                        </>
                                    } />
                            </Grid>


                            {
                                isInternUser ?
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <MyTextField
                                            id="client_observation"
                                            outerlabel="Observações"
                                            value={inputClientObservation}
                                            onChange={changeClientObservation}
                                            multiline={true}
                                            rows={4}
                                            rowsMax={4}
                                            inputProps={{ maxLength: CLIENT_OBSERVATION_MAX_LENGTH }}
                                            placeholder="Anotações internas sobre o cliente"
                                            fullWidth />
                                        <Typography className={classes.observationCounter}>
                                            {inputClientObservation.length + '/' + CLIENT_OBSERVATION_MAX_LENGTH}
                                        </Typography>
                                    </Grid> : null
                            }

                            {
                                inputClientAssistRpps && inputClientUfRpps &&
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Typography style={{ color: 'red' }}>UF RPPS + ASSIST está sendo considerado como carteira complementar Militar (Verificar caso de Roraima)</Typography>

                                </Grid>
                            }

                        </Grid>

                    </form>
                </div>


            </DefaultScrollWithHeaderContent>

            <SelectAndCropImageModal
                open={showSelectAndCropImage}
                imgSrc={imgSrc}
                handleAction={(action) => handleActionSelectedAndCropImageModal(action)} />

            <ConfirmActionModal
                open={openCotizationSegregationModal}
                title="Cotização Segregada"
                message="Ao sinalizar COTIZAÇÃO SEGREGADA para um cliente o seu fechamento é resetado, deseja prosseguir com a operação?"
                handleAction={handleCotizationSegregationModalAction} />

            {
                openUpdateAssetsModal && clientOnScreen ?
                    <UpdateAssetsInitsModal
                        open={openUpdateAssetsModal}
                        client={clientOnScreen}
                        oldInitPortfolio={oldInitPortfolio}
                        newInitPortfolio={selectedDate}
                        handleClose={() => setOpenUpdateAssetsModal(false)}
                        handleAction={(e, updateOrNot) => {
                            setOpenUpdateAssetsModal(false)
                            doUpdateClient(e, updateOrNot)
                        }} />

                    : null
            }


        </div >
    );
}
